import styled, { CSSProp } from 'styled-components';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

export const ListWrapperStyled = styled.div<{ $isListEmpty?: boolean }>`
  min-height: ${({ $isListEmpty }): CSSProp => ($isListEmpty ? '20rem' : '50rem')};
  position: relative;
  display: grid;
`;

export const PlansListStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30rem, 35rem));
  justify-content: center;
  gap: clamp(3rem, 2vw, 5rem);
`;

export const HeaderStyled = styled.div`
  margin-bottom: 2rem;
`;

export const CartButtonStyled = styled.button`
  margin: 8rem auto 3rem;
  width: 30rem;
`;

export const CustomDisclaimerStyled = styled.div`
  background-color: ${colors.neutral.white};
  color: ${colors.neutral[900]};
  border-radius: 1rem;
  padding: 2rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  text-align: center;
  margin: 0 auto 8rem;
  max-width: 70%;

  * {
    margin: 0;
  }
`;

// TODO remove when HeaderWithBcBlock will be updated
/** @deprecated use styled components instead */
const styles = {
  header: {
    marginBottom: '2rem',
  },
};
const createStyles = createUseStyles(styles);
export { createStyles };
